/* eslint-disable @typescript-eslint/no-explicit-any */
import { RefObject, useEffect, useRef } from 'react';
import { ScheduleComponent } from '@syncfusion/ej2-react-schedule';

/**
 * Aggiorna il calendario Syncfusion quando TUTTI i dati sono pronti.
 *
 * Rileva la transizione isLoading: true → false e a quel punto:
 * 1. Assegna il nuovo dataSource e chiama dataBind() per sincronizzare gli eventi
 *
 * Usa un ref per il dataSource così il valore è sempre il più recente,
 * evitando race condition con setState asincrono.
 */
export function useSchedulerRefresh(
  scheduleObj: RefObject<ScheduleComponent | null>,
  isLoading: boolean
) {
  const prevIsLoading = useRef(isLoading);

  useEffect(() => {
    const wasLoading = prevIsLoading.current;
    prevIsLoading.current = isLoading;

    // Refresh solo alla transizione loading → ready
    if (!wasLoading || isLoading) return;
    if (!scheduleObj.current) return;

    try {
      if (!scheduleObj.current) return;

      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 100);
    } catch (error) {
      /* empty */
    }
  }, [scheduleObj, isLoading]);
}
